import { defineMessages } from 'react-intl-next';
export var colorNames = defineMessages({
  defaultWhite: {
    id: 'color-picker.default-white',
    description: 'Name of default white color',
    defaultMessage: 'Default white'
  },
  white: {
    id: 'color-picker.white',
    description: 'Name of white color',
    defaultMessage: 'White'
  },
  lightGray: {
    id: 'color-picker.light-gray',
    description: 'Name of light gray color',
    defaultMessage: 'Light gray'
  },
  lightBlue: {
    id: 'color-picker.light-blue',
    description: 'Name of light blue color',
    defaultMessage: 'Light blue'
  },
  lightPurple: {
    id: 'color-picker.light-purple',
    description: 'Name of light purple color',
    defaultMessage: 'Light purple'
  },
  lightMagenta: {
    id: 'color-picker.light-magenta',
    description: 'Name of light magenta color',
    defaultMessage: 'Light magenta'
  },
  lightRed: {
    id: 'color-picker.light-red',
    description: 'Name of light red color',
    defaultMessage: 'Light red'
  },
  lightOrange: {
    id: 'color-picker.light-orange',
    description: 'Name of light orange color',
    defaultMessage: 'Light orange'
  },
  lightYellow: {
    id: 'color-picker.light-yellow',
    description: 'Name of light yellow color',
    defaultMessage: 'Light yellow'
  },
  lightLime: {
    id: 'color-picker.light-lime',
    description: 'Name of light lime color',
    defaultMessage: 'Light lime'
  },
  lightGreen: {
    id: 'color-picker.light-green',
    description: 'Name of light green color',
    defaultMessage: 'Light green'
  },
  lightTeal: {
    id: 'color-picker.light-teal',
    description: 'Name of light teal color',
    defaultMessage: 'Light teal'
  },
  subtleGray: {
    id: 'color-picker.subtle-gray',
    description: 'Name of subtle gray color',
    defaultMessage: 'Subtle gray'
  },
  subtleBlue: {
    id: 'color-picker.subtle-blue',
    description: 'Name of subtle blue color',
    defaultMessage: 'Subtle blue'
  },
  subtlePurple: {
    id: 'color-picker.subtle-purple',
    description: 'Name of subtle purple color',
    defaultMessage: 'Subtle purple'
  },
  subtleMagenta: {
    id: 'color-picker.subtle-magenta',
    description: 'Name of subtle magenta color',
    defaultMessage: 'Subtle magenta'
  },
  subtleRed: {
    id: 'color-picker.subtle-red',
    description: 'Name of subtle red color',
    defaultMessage: 'Subtle red'
  },
  subtleOrange: {
    id: 'color-picker.subtle-orange',
    description: 'Name of subtle orange color',
    defaultMessage: 'Subtle orange'
  },
  subtleYellow: {
    id: 'color-picker.subtle-yellow',
    description: 'Name of subtle yellow color',
    defaultMessage: 'Subtle yellow'
  },
  subtleLime: {
    id: 'color-picker.subtle-lime',
    description: 'Name of subtle lime color',
    defaultMessage: 'Subtle lime'
  },
  subtleGreen: {
    id: 'color-picker.subtle-green',
    description: 'Name of subtle green color',
    defaultMessage: 'Subtle green'
  },
  subtleTeal: {
    id: 'color-picker.subtle-teal',
    description: 'Name of subtle teal color',
    defaultMessage: 'Subtle teal'
  },
  gray: {
    id: 'color-picker.gray',
    description: 'Name of gray color',
    defaultMessage: 'Gray'
  },
  blue: {
    id: 'color-picker.blue',
    description: 'Name of blue color',
    defaultMessage: 'Blue'
  },
  purple: {
    id: 'color-picker.purple',
    description: 'Name of purple color',
    defaultMessage: 'Purple'
  },
  magenta: {
    id: 'color-picker.magenta',
    description: 'Name of magenta color',
    defaultMessage: 'Magenta'
  },
  red: {
    id: 'color-picker.red',
    description: 'Name of red color',
    defaultMessage: 'Red'
  },
  orange: {
    id: 'color-picker.orange',
    description: 'Name of orange color',
    defaultMessage: 'Orange'
  },
  yellow: {
    id: 'color-picker.yellow',
    description: 'Name of yellow color',
    defaultMessage: 'Yellow'
  },
  lime: {
    id: 'color-picker.lime',
    description: 'Name of lime color',
    defaultMessage: 'Lime'
  },
  green: {
    id: 'color-picker.green',
    description: 'Name of green color',
    defaultMessage: 'Green'
  },
  teal: {
    id: 'color-picker.teal',
    description: 'Name of teal color',
    defaultMessage: 'Teal'
  },
  boldGray: {
    id: 'color-picker.bold-gray',
    description: 'Name of bold gray color',
    defaultMessage: 'Bold gray'
  },
  boldBlue: {
    id: 'color-picker.bold-blue',
    description: 'Name of bold blue color',
    defaultMessage: 'Bold blue'
  },
  boldPurple: {
    id: 'color-picker.bold-purple',
    description: 'Name of bold purple color',
    defaultMessage: 'Bold purple'
  },
  boldMagenta: {
    id: 'color-picker.bold-magenta',
    description: 'Name of bold magenta color',
    defaultMessage: 'Bold magenta'
  },
  boldRed: {
    id: 'color-picker.bold-red',
    description: 'Name of bold red color',
    defaultMessage: 'Bold red'
  },
  boldOrange: {
    id: 'color-picker.bold-orange',
    description: 'Name of bold orange color',
    defaultMessage: 'Bold orange'
  },
  boldYellow: {
    id: 'color-picker.bold-yellow',
    description: 'Name of bold yellow color',
    defaultMessage: 'Bold yellow'
  },
  boldLime: {
    id: 'color-picker.bold-lime',
    description: 'Name of bold lime color',
    defaultMessage: 'Bold lime'
  },
  boldGreen: {
    id: 'color-picker.bold-green',
    description: 'Name of bold green color',
    defaultMessage: 'Bold green'
  },
  boldTeal: {
    id: 'color-picker.bold-teal',
    description: 'Name of bold teal color',
    defaultMessage: 'Bold teal'
  },
  defaultBlue: {
    id: 'color-picker.default-blue',
    description: 'Name of default blue color',
    defaultMessage: 'Default blue'
  }
});